import client from './client';

// Touchstream Configuration Management
export const getTouchstreamConfigs = async () => {
  const response = await client.get('/api/touchstream/configs');
  return response.data.configs;
};

export const createTouchstreamConfig = async (configData) => {
  const response = await client.post('/api/touchstream/configs', configData);
  return response.data;
};

export const updateTouchstreamConfig = async (configId, configData) => {
  const response = await client.put(`/api/touchstream/configs/${configId}`, configData);
  return response.data;
};

export const deleteTouchstreamConfig = async (configId) => {
  const response = await client.delete(`/api/touchstream/configs/${configId}`);
  return response.data;
};

export const getTouchstreamConfig = async (configId) => {
  const response = await client.get(`/api/touchstream/configs/${configId}`);
  return response.data;
};

export const getTouchstreamStreams = async (configId) => {
  const response = await client.get(`/api/touchstream/configs/${configId}/streams`);
  return response.data;
};

export const getTouchstreamStreamOptions = async (configId) => {
  const response = await client.get(`/api/touchstream/configs/${configId}/stream-options`);
  return response.data;
};
